import type { CurrentUserType } from '@common/types';
import type { RealmType } from '@common/types/RealmType';
import type { ThemeType } from '@common/types/ThemeType';
import { usePreferredDark } from '@vueuse/core';
import { defineStore } from 'pinia';

export const useUiStore = defineStore('uiStore', {
  state: () => {
    return {
      currentUser: {
        displayName: '',
        id: '',
        isAuthenticated: false,
      } as CurrentUserType,

      realm: {
        id: '',
        name: '',
        logoLight: '',
        logoDark: '',
      } as RealmType,

      theme: {
        color: 'blue',
        scheme: 'system',
      } as ThemeType,
    };
  },
  getters: {
    realmLogo(): string {
      return this.themeScheme === 'light'
        ? this.realm.logoLight
        : this.realm.logoDark;
    },

    themeScheme(): 'dark' | 'light' {
      const isDarkMode = usePreferredDark();

      if (this.theme.scheme === 'system') {
        return isDarkMode.value ? 'dark' : 'light';
      }

      return this.theme.scheme;
    },
  },
  actions: {
    setCurrentUser(currentUser: CurrentUserType) {
      this.currentUser = currentUser;
    },

    setRealm(realm: RealmType) {
      this.realm = realm;
    },

    setRealmId(id: string) {
      this.realm.id = id;
    },

    setTheme(theme: ThemeType) {
      this.theme = theme;
    },
  },
});